import React, { useCallback } from 'react';

import { Box } from '@vk-hr-tek/ui/Box';
import { Typography } from '@vk-hr-tek/ui/Typography';
import { toDateDeclensionMonth } from '@vk-hr-tek/ui/format';
import { Avatar } from '@vk-hr-tek/ui/Avatar';
import { Link } from '@vk-hr-tek/ui/Link';

import { modules } from '@app/modules';

import { PhotoParams, SearchNewsItem } from '../SearchInput.types';
import { useUrlWithPrefix } from '../../../../hooks';

interface SearchOptionNewsProps {
  option: SearchNewsItem;
  loadPhoto: (params: PhotoParams) => Promise<Blob>;
}

export const SearchOptionNews = ({
  option,
  loadPhoto,
}: SearchOptionNewsProps) => {
  const handleLoadPhoto = useCallback(async () => {
    return loadPhoto({
      type: 'news',
      id: option.cover_att_id || '',
    });
  }, [loadPhoto, option.cover_att_id]);

  const urlWithPrefix = useUrlWithPrefix();
  const href = `/${modules.news.basename}/${option.id}`;

  return (
    <Box width="100%">
      <Link {...urlWithPrefix(href)} variant="simple" display="block">
        <Box width="100%" p="8" display="flex" gap="12" cursor="pointer">
          <Box height={40} width={40}>
            <Avatar loadPhoto={handleLoadPhoto} variant="square" />
          </Box>
          <Box flex={1} display="flex" flexDirection="column">
            <Box display="flex" justifyContent="space-between">
              <Typography variant="caption" color="text.light.tertirary">
                {option.category}
              </Typography>
              <Typography variant="caption" color="text.light.tertirary">
                {toDateDeclensionMonth(option.date)}
              </Typography>
            </Box>
            <Box>
              <Typography variant="body3" color="text.light.primary">
                {option.title}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Link>
    </Box>
  );
};
